
//============================================================================
//file_description: 设备检测工具，用于判断当前设备类型
//============================================================================
//skills_usage: project-executor
//skill_path: .codex/skills/project-executor/SKILL.md
//skill_description: 用于任务执行和状态跟踪，创建工具函数
//created_at: 2026-03-12 11:00:00
//task_name: create-device-detector

import React from 'react';

export const isMobileDevice = (): boolean => {
  // 检查用户代理字符串
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // 移动端正则表达式
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  
  // 检查屏幕宽度
  const screenWidth = window.innerWidth;
  const isSmallScreen = screenWidth <= 768;
  
  // 检查触摸支持
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return mobileRegex.test(userAgent) || isSmallScreen || hasTouch;
};

export const getDeviceType = (): 'mobile' | 'tablet' | 'desktop' => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  const screenWidth = window.innerWidth;
  
  // 平板设备检测
  const tabletRegex = /iPad|Android/i;
  const isTablet = tabletRegex.test(userAgent) && screenWidth > 768 && screenWidth <= 1024;
  
  if (isTablet) {
    return 'tablet';
  }
  
  if (isMobileDevice()) {
    return 'mobile';
  }
  
  return 'desktop';
};

export const useDeviceDetection = () => {
  const [isMobile, setIsMobile] = React.useState(isMobileDevice());
  const [deviceType, setDeviceType] = React.useState(getDeviceType());

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
      setDeviceType(getDeviceType());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isMobile, deviceType };
};
